import type { AgentApiCompaniesSummaryItem } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

type SummaryCompaniesResponse = {
  records: AgentApiCompaniesSummaryItem[];
};

/** id 指定で企業を復元する（最大500件は summary_companies 側で担保） */
export default function useFetchCompaniesByIds(ids: number[]) {
  const sortedIds = [...new Set(ids)].sort((a, b) => a - b);

  return useQuery({
    queryKey: ['/agent/api/summary_companies', 'ids', sortedIds],
    queryFn: async () => {
      const params = new URLSearchParams();
      sortedIds.forEach((id) => params.append('ids[]', String(id)));
      const response = await fetch(`/agent/api/summary_companies?${params}`);
      if (!response.ok) throw new Error('企業情報の取得に失敗しました');
      const data: SummaryCompaniesResponse = await response.json();
      return data.records;
    },
    enabled: sortedIds.length > 0,
  });
}
